export default "__VITE_ASSET__BDu20VEp__"